<template>
  <div class="fill-height">
    <Toolbar />
    <v-row no-gutters class="fill-height">
      <v-col cols="12" sm="6" class="pa-5 white">
        <img
          class="mb-3"
          width="100"
          src="https://s3-eu-west-1.amazonaws.com/file.usail.es/static/usail-logo-color.svg"
          alt="USAIL"
        />
        <p>
          {{ $t('message.help.paragraph') }}
        </p>

        <div class="grey lighten-4 pa-3 mb-3">
          <div class="body-2">
            {{ $t('message.help.technical_service.title') }}
          </div>
          <p>
            <v-icon size="14" class="mr-1">mdi-phone</v-icon>
            <a href="tel:+34986064381">(+34) 986 064 381</a>
            <br />
            <v-icon size="14" class="mr-1">mdi-email-outline</v-icon>
            <a href="mailto:noc@usail.es">noc@usail.es</a>
          </p>
          <p>
            {{ $t('message.help.technical_service.paragraph.1') }}
          </p>
          <p class="mb-0">
            {{ $t('message.help.technical_service.paragraph.2') }}
          </p>
        </div>

        <div class="grey lighten-4 pa-3 mb-3">
          <div class="body-2">
            {{ $t('message.help.administrative_and_billing.title') }}
          </div>

          <p>
            <v-icon size="14" class="mr-1">mdi-phone</v-icon>
            <a href="tel:+34986064380">(+34) 986 064 380</a>
          </p>
          <p class="mb-0">
            {{ $t('message.help.administrative_and_billing.paragraph') }}
          </p>
        </div>
      </v-col>
      <v-col cols="12" sm="6" class="pa-5" :class="{ 'border-left': $vuetify.breakpoint.smAndUp }">
        <h2 class="headline mb-4">{{ $t('message.faq.title') }}</h2>
        <v-expansion-panels :accordion="true">
          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ $t('message.faq.what_is_usail_connect.title') }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>
                {{ $t('message.faq.what_is_usail_connect.paragraph.1') }}
              </p>
              <p v-html="$t('message.faq.what_is_usail_connect.paragraph.2')"></p>
              <p v-html="$t('message.faq.what_is_usail_connect.paragraph.3')"></p>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ $t('message.faq.one_of_my_sites_does_not_appear_in_connect.title') }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>
                {{ $t('message.faq.one_of_my_sites_does_not_appear_in_connect.paragraph.1') }}
              </p>
              <p>
                {{ $t('message.faq.one_of_my_sites_does_not_appear_in_connect.paragraph.2') }}
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ $t('message.faq.what_is_the_difference_between_recurring_and_on_demand_services.title') }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>
                {{ $t('message.faq.what_is_the_difference_between_recurring_and_on_demand_services.paragraph.1') }}
              </p>
              <p>
                {{ $t('message.faq.what_is_the_difference_between_recurring_and_on_demand_services.paragraph.2') }}
              </p>
              <p>
                {{ $t('message.faq.what_is_the_difference_between_recurring_and_on_demand_services.paragraph.3') }}
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ $t('message.faq.i_do_not_have_an_internet_connection_on_my_site_what_can_i_do.title') }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <p
                v-html="$t('message.faq.i_do_not_have_an_internet_connection_on_my_site_what_can_i_do.paragraph.1')"
              ></p>
              <p>
                {{ $t('message.faq.i_do_not_have_an_internet_connection_on_my_site_what_can_i_do.paragraph.2') }}
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ $t('message.faq.i_receive_an_error_when_programming_stops.title') }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>
                {{ $t('message.faq.i_receive_an_error_when_programming_stops.paragraph.1') }}
              </p>
              <p>
                {{ $t('message.faq.i_receive_an_error_when_programming_stops.paragraph.2') }}
              </p>
              <p>
                {{ $t('message.faq.i_receive_an_error_when_programming_stops.paragraph.3') }}
              </p>
              <p>
                {{ $t('message.faq.i_receive_an_error_when_programming_stops.paragraph.4') }}
              </p>
              <p>
                {{ $t('message.faq.i_receive_an_error_when_programming_stops.paragraph.5') }}
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ $t('message.faq.can_i_pay_my_services_by_direct_debit.title') }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <p v-html="$t('message.faq.can_i_pay_my_services_by_direct_debit.paragraph')"></p>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ $t('message.faq.transfer_and_direct_debit_payment_options_are_deactivated.title') }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>
                {{ $t('message.faq.transfer_and_direct_debit_payment_options_are_deactivated.paragraph.1') }}
              </p>
              <p>
                {{ $t('message.faq.transfer_and_direct_debit_payment_options_are_deactivated.paragraph.2') }}
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ $t('message.faq.is_it_safe_to_provide_my_credit_or_debit_card_information.title') }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>
                {{ $t('message.faq.is_it_safe_to_provide_my_credit_or_debit_card_information.paragraph') }}
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ $t('message.faq.what_kind_of_cards_can_i_use_to_make_my_payments.title') }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>
                {{ $t('message.faq.what_kind_of_cards_can_i_use_to_make_my_payments.paragraph.1') }}
              </p>
              <p>
                {{ $t('message.faq.what_kind_of_cards_can_i_use_to_make_my_payments.paragraph.2') }}
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Toolbar from '@/components/Toolbar'
export default {
  name: 'Support',
  components: { Toolbar }
}
</script>

<style lang="stylus" scopped>
.no-x-pad
  .v-expansion-panel__header
    padding-left 0
    padding-right 0
</style>
